//check list - Bengal State Registration Widget (Collection-based)
document.addEventListener('DOMContentLoaded', function() {

  const dropdown = document.getElementById('availableOption');
  if (!dropdown) return;

  const errorMessage = document.getElementById('error_message');
  
  // Find Horizon's add to cart button
  const productBtn = document.querySelector('.product-form__submit') || 
                     document.querySelector('[name="add"]') ||
                     document.querySelector('.add-to-cart');

  // Disable buy button on load
  if (productBtn) productBtn.disabled = true;

  // Get the product's collections from the page
  // These are rendered as data attributes on the state-registration div
  const widget = document.querySelector('.state-registration-widget');
  const productCollections = widget ? 
    JSON.parse(widget.getAttribute('data-collections') || '[]') : [];

  function handleDropdownChange() {
    const selectedValue = dropdown.value;
    if (!selectedValue) return;

    // Check if selected state is in product's collections
    const found = productCollections.some(function(collection) {
      return collection.toLowerCase() === selectedValue.toLowerCase();
    });

    if (!found) {
      if (productBtn) productBtn.disabled = true;
      if (errorMessage) errorMessage.textContent = "We're sorry, this product is not registered for retail in your state";
    } else {
      if (productBtn) productBtn.disabled = false;
      if (errorMessage) errorMessage.textContent = 'Woohoo! This product is registered for retail in your state!';
    }
  }

  dropdown.addEventListener('change', handleDropdownChange);
});